<template>
  <div class="container-fluid">
    <div class="row">
      <side-bar v-if="period" :period="period"></side-bar>

      <main role="main" class="col-md-10 ml-sm-auto col-lg-10 fill page">
        <component v-bind:is="componentName" v-if="period" :period="period"></component>
      </main>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      days: [],
      selectedDay: null,
      period: [
        this.$route.params.start != undefined
          ? moment(this.$route.params.start, 'YYYYY-MM-DD')
          : moment().subtract(1, 'month'),
        this.$route.params.end != undefined
          ? moment(this.$route.params.end, 'YYYYY-MM-DD')
          : moment(),
      ],
    }
  },
  components: {
    'side-bar': () => import('../Sidebar'),
    user: () => import('../User'),
    site: () => import('../Site'),
    streamprofile: () => import('../StreamProfile'),
    session: () => import('../Session'),
    battery: () => import('../Battery'),
    emailsupport: () => import('../EmailSupport'),
  },
  computed: {
    componentName() {
      return this.$route.name.toLowerCase()
    },
  },
  methods: {},
}
</script>
